/**
 * BRXCheckoutReturn
 *
 * Renders the checkout-return page and wires its CTAs.
 * Sections: treatment plan (top), what's included, change selection,
 * how it works, reviews carousel, FAQs accordion.
 *
 * Usage:
 *   window.BRXCheckoutReturn.mount(sectionRoot, options);
 */
(function () {

    // -------------------------------------------------------------------------
    // Placeholder data — fill in before launch
    // -------------------------------------------------------------------------

    var REVIEWS = [
        {author: "Drew T.", stars: 5, text: "One month on BraveRX and everything has improved. Libido, erection quality, and just general confidence. Genuinely happy with this product" },
        {author: "Michael", stars: 5, text: "Apomorphine really does enhance things in an incredible way. I thought this was just for erections but it's changed the way I approach my job and the gym too." },
        {author: "Brian", stars: 5, text: "It took a couple days, but I'm definitely getting more erections on this stuff now. Even my wife says it’s bigger." },
        {author: "Patrick", stars: 5, text: "I signed up using my phone, and the entire process took just a few minutes. Within an hour my doctor approved my prescription, perfectly timed for the weekend." },
        // { author: 'John D.', stars: 5, text: 'Lorem ipsum...' }
    ];

    var FAQS = [
        // { question: 'How long does approval take?', answer: '...' }
        {question: "If Viagra or Cialis didn't work for me, will BraveRX?", answer: "BraveRX is built for men who are tired of inconsistent results from old‑school, one‑ingredient pills. By combining a clinically trusted PDE5 inhibitors with a modern arousal‑enhancing formula, BraveRX is designed to deliver stronger, more reliable outcomes than standard Viagra or Cialis alone. Most men who were disappointed with traditional pills choose BraveRX as their next‑level solution."},
        {question: "How long do the effects last?", answer: "Up to 36 hours. Tadalafil — one of BraveRX's active ingredients — is clinically studied to support erectile function for up to 36 hours after dosing, giving you a wide window of spontaneity without re-dosing."},
        {question: "How fast does BraveRX work?", answer: "Fast — typically within 15 minutes or less. The fast-acting sublingual formula is designed for rapid onset, with most men ready in 15–30 minutes."},
        {question: "Where is BraveRX made?", answer: "All BraveRX products are made in the USA by licensed compounding pharmacies. Specifically, BraveRX has partnered with two pharmacies, one in Texas and one in New Jersey. Each medication undergoes regular audits and routine batch testing, and is certified to meet industry-standard accuracy and safety specifications."},
    ];

    var INCLUDED_ITEMS = [
        'Medication, supplies, and instructions',
        'Ongoing clinician support',
        'Free discreet shipping',
        '100% Money-Back Guarantee*',
        'Cancel anytime, come back anytime'
    ];

    var GROUP_IMAGES = {
        'mint-tablets': 'https://cdn.shopify.com/s/files/1/0897/3405/4167/files/checkoutReturn-tablet.webp',
        'capsules':    'https://cdn.shopify.com/s/files/1/0897/3405/4167/files/checkoutReturn-capsule02.webp'
    };

    var PRODUCT_STATS = {
        'surge-max':        92,
        'surge-daily-pro':  91,
        'surge-daily-core': 90,
        'prime-max-pro':    89,
        'prime-max-core':   88,
        'prime-daily-pro':  85,
        'prime-daily-core': 82
    };

    // -------------------------------------------------------------------------
    // Usage chips (treatment plan top section)
    // -------------------------------------------------------------------------

    var usageMap = {
        as_needed: {
            bestForLabel:      'Best for',
            bestForValue:      'In the moment',
            durationLabel:     'Supports you',
            durationValue:     'Up to 36 hours',
            instructionsLabel: 'Take',
            instructionsValue: '15 min before sex'
        },
        daily: {
            bestForLabel:      'Best for',
            bestForValue:      'Always ready',
            durationLabel:     'Supports you',
            durationValue:     '24/7 support',
            instructionsLabel: 'Take',
            instructionsValue: 'Once daily'
        }
    };

    // -------------------------------------------------------------------------
    // Utilities
    // -------------------------------------------------------------------------

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g,  '&amp;')
            .replace(/</g,  '&lt;')
            .replace(/>/g,  '&gt;')
            .replace(/"/g,  '&quot;')
            .replace(/'/g,  '&#39;');
    }

    function formatMoney(cents) {
        return '$' + ((cents || 0) / 100).toFixed(0);
    }

    function calcDiscount(promoData, priceCents) {
        if (!promoData) return 0;
        if (promoData.type === 'dollars') return Math.round(promoData.value * 100);
        if (promoData.type === 'percent') return Math.round(priceCents * (promoData.value / 100));
        return 0;
    }

    // -------------------------------------------------------------------------
    // Catalog helpers
    // -------------------------------------------------------------------------

    function findProductByHandleInCatalog(catalog, handle) {
        var groups = (catalog && catalog.groups) ? catalog.groups : [];
        for (var gi = 0; gi < groups.length; gi++) {
            var products = groups[gi].products || [];
            for (var pi = 0; pi < products.length; pi++) {
                if (products[pi].handle === handle) return products[pi];
            }
        }
        return null;
    }

    function buildAllCatalogProducts(catalog) {
        var groups = (catalog && catalog.groups) ? catalog.groups : [];
        var seen   = {};
        var result = [];
        for (var gi = 0; gi < groups.length; gi++) {
            var group    = groups[gi];
            var products = group.products || [];
            for (var pi = 0; pi < products.length; pi++) {
                var p   = products[pi];
                var key = p.handle;
                if (!seen[key]) {
                    seen[key] = true;
                    result.push({
                        product:    p,
                        groupKey:   group.key   || '',
                        groupLabel: group.label || group.key || ''
                    });
                }
            }
        }
        return result;
    }

    // -------------------------------------------------------------------------
    // Variant synthesis for the current selection
    // Mirrors applyDailyPairTransform in checkout/summary/checkout-init.js
    // -------------------------------------------------------------------------

    function buildSelectionVariants(product, catalog) {
        if (!product) return null;

        // Native multi-variant product: use dose/count variants directly
        if (product.hasVariants && product.variants && product.variants.length) {
            return {
                optionName:  product.variantOptionName || 'Select Your Dose',
                variants:    product.variants,
                isDailyPair: false
            };
        }

        // surge-daily pair: Pro and Core as formula variants
        if (product.handle === 'surge-daily-pro' || product.handle === 'surge-daily-core') {
            var sdPro  = findProductByHandleInCatalog(catalog, 'surge-daily-pro');
            var sdCore = findProductByHandleInCatalog(catalog, 'surge-daily-core');
            if (sdPro && sdCore) {
                return {
                    optionName: 'Select Your Formula',
                    variants: [
                        { id: sdPro.ccProductId,  ccProductId: sdPro.ccProductId,  medId: sdPro.medId,  title: 'Pro Formula',  priceCents: sdPro.priceCents  },
                        { id: sdCore.ccProductId, ccProductId: sdCore.ccProductId, medId: sdCore.medId, title: 'Core Formula', priceCents: sdCore.priceCents }
                    ],
                    isDailyPair: true
                };
            }
        }

        // prime-daily pair: Pro and Core as formula variants
        if (product.handle === 'prime-daily-pro' || product.handle === 'prime-daily-core') {
            var pdPro  = findProductByHandleInCatalog(catalog, 'prime-daily-pro');
            var pdCore = findProductByHandleInCatalog(catalog, 'prime-daily-core');
            if (pdPro && pdCore) {
                return {
                    optionName: 'Select Your Formula',
                    variants: [
                        { id: pdPro.ccProductId,  ccProductId: pdPro.ccProductId,  medId: pdPro.medId,  title: 'Pro Formula',  priceCents: pdPro.priceCents  },
                        { id: pdCore.ccProductId, ccProductId: pdCore.ccProductId, medId: pdCore.medId, title: 'Core Formula', priceCents: pdCore.priceCents }
                    ],
                    isDailyPair: true
                };
            }
        }

        return null;
    }

    // -------------------------------------------------------------------------
    // Treatment plan — top section
    // -------------------------------------------------------------------------

    function renderUsageChips(usageType, vertical) {
        var usage = usageMap[usageType];
        if (!usage) return '';

        function chip(label, value) {
            return '<div class="tw-flex tw-justify-center tw-flex-col tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-black/10 tw-px-3 tw-py-2 md:tw-py-3 tw-text-center">' +
                '<span class="tw-text-xs md:tw-text-sm tw-leading-none tw-text-charcoal/60 tw-font-medium">'                  + escapeHtml(label) + '</span>' +
                '<span class="tw-text-sm md:tw-text-base tw-font-medium tw-leading-none md:tw-leading-none tw-text-charcoal">' + escapeHtml(value) + '</span>' +
                '</div>';
        }

        var containerClass = vertical ? 'tw-flex tw-flex-col tw-gap-2' : 'tw-grid tw-grid-cols-3 tw-gap-2';

        return '<div class="' + containerClass + '">' +
            chip(usage.bestForLabel,      usage.bestForValue) +
            chip(usage.durationLabel,     usage.durationValue) +
            chip(usage.instructionsLabel, usage.instructionsValue) +
            '</div>';
    }

    function renderAccordionItem(title, contentHtml) {
        if (!contentHtml) return '';

        return '<div class="tw-border-b tw-border-black/10" data-accordion-item>' +
            '<button type="button" class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-4 tw-py-4 tw-text-left" data-accordion-trigger aria-expanded="false">' +
                '<span class="tw-text-base tw-font-medium tw-text-charcoal">' + escapeHtml(title) + '</span>' +
                '<span class="material-symbols-outlined tw-text-[20px] tw-text-charcoal tw-transition-transform tw-duration-200" data-accordion-icon aria-hidden="true">expand_more</span>' +
            '</button>' +
            '<div class="tw-grid tw-grid-rows-[0fr] tw-transition-[grid-template-rows] tw-duration-200 tw-ease-out" data-accordion-panel aria-hidden="true">' +
                '<div class="tw-overflow-hidden">' +
                    '<div class="tw-pb-4 tw-text-sm tw-leading-relaxed tw-text-charcoal/80">' + contentHtml + '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    }

    function initAccordions(container) {
        var accordions = container.querySelectorAll('[data-brx-return-accordion]');

        accordions.forEach(function (accordion) {
            if (accordion.dataset.initialized === 'true') return;
            accordion.dataset.initialized = 'true';

            var items = accordion.querySelectorAll('[data-accordion-item]');

            function closeItem(item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                var panel   = item.querySelector('[data-accordion-panel]');
                var icon    = item.querySelector('[data-accordion-icon]');
                if (!trigger || !panel) return;
                trigger.setAttribute('aria-expanded', 'false');
                panel.setAttribute('aria-hidden', 'true');
                panel.classList.remove('tw-grid-rows-[1fr]');
                panel.classList.add('tw-grid-rows-[0fr]');
                if (icon) icon.classList.remove('tw-rotate-180');
            }

            function openItem(item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                var panel   = item.querySelector('[data-accordion-panel]');
                var icon    = item.querySelector('[data-accordion-icon]');
                if (!trigger || !panel) return;
                trigger.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-hidden', 'false');
                panel.classList.remove('tw-grid-rows-[0fr]');
                panel.classList.add('tw-grid-rows-[1fr]');
                if (icon) icon.classList.add('tw-rotate-180');
            }

            items.forEach(function (item) {
                var trigger = item.querySelector('[data-accordion-trigger]');
                if (!trigger) return;
                trigger.addEventListener('click', function () {
                    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
                    items.forEach(function (other) { if (other !== item) closeItem(other); });
                    if (isOpen) closeItem(item); else openItem(item);
                });
            });
        });
    }

    function buildIngredientsHtml(ingredients) {
        if (!ingredients || !ingredients.length) return '';
        return '<ul class="tw-space-y-3 tw-list-none tw-p-0 tw-m-0">' +
            ingredients.map(function (ing) {
                var label = escapeHtml(ing.title) + (ing.amount ? ' ' + escapeHtml(ing.amount) : '');
                return '<li>' +
                    '<span class="tw-font-medium tw-text-charcoal">' + label + '</span>' +
                    (ing.description ? '<p class="tw-mt-0.5 tw-text-charcoal/70 tw-m-0">' + escapeHtml(ing.description) + '</p>' : '') +
                    '</li>';
            }).join('') +
            '</ul>';
    }

    function renderSummary(product) {
        var imageUrl     = escapeHtml(product.imageUrl     || '');
        var title        = escapeHtml(product.title        || '');
        var displayTitle = escapeHtml(product.displayTitle || '');
        var usageType    = product.usageType || '';

        var titleDescHtml =
            '<h3 class="tw-normal-case tw-text-charcoal tw-text-xl sm:tw-text-2xl tw-text-left md:tw-text-center">' + title + '</h3>' +
            (displayTitle ? '<div class="tw-mt-1 tw-text-base tw-text-light-charcoal tw-text-left md:tw-text-center">' + displayTitle + '</div>' : '');

        return '<div class="tw-bg-white tw-py-4 md:tw-p-0">' +
            '<h3 class="embeddables-return__section-heading">Your Treatment Plan</h3>' +
            '<div class="tw-flex tw-gap-4 md:tw-items-center">' +
                '<div class="tw-h-[100px] tw-w-[100px] tw-shrink-0 sm:tw-w-[150px] sm:tw-h-[150px] md:tw-h-[240px] md:tw-w-[240px]">' +
                    (imageUrl
                        ? '<img src="' + imageUrl + '" alt="' + title + '" class="tw-h-full tw-w-full tw-rounded-md tw-object-cover" loading="eager" />'
                        : '') +
                '</div>' +
                '<div class="tw-min-w-0 tw-flex-1">' +
                    '<div class="md:tw-hidden">' + titleDescHtml + '</div>' +
                    '<div class="tw-hidden md:tw-block">' + renderUsageChips(usageType, true) + '</div>' +
                '</div>' +
            '</div>' +
            '<div class="tw-hidden md:tw-block tw-mt-4">' + titleDescHtml + '</div>' +
        '</div>';
    }

    function renderDetails(product, variant) {
        var usageType           = product.usageType || '';
        var descriptionHtml     = product.descriptionHtml || '';
        var ingredients         = (variant && variant.ingredients && variant.ingredients.length)
            ? variant.ingredients
            : (product.ingredients || []);
        var activeIngredientsHtml = buildIngredientsHtml(ingredients);
        var whatToKnowHtml        = product.whatToKnowHtml || '';
        var howToTakeHtml         = product.howToTakeHtml  || '';
        var hasAccordion          = activeIngredientsHtml || whatToKnowHtml || howToTakeHtml;
        var statPct               = PRODUCT_STATS[product.handle] != null ? PRODUCT_STATS[product.handle] : 91;

        return '<div class="tw-bg-white tw-pt-2">' +
            '<div class="md:tw-hidden">' + renderUsageChips(usageType) + '</div>' +
            '<div class="tw-mt-4 md:tw-mt-0 tw-text-sm sm:tw-text-base tw-text-light-charcoal tw-text-left md:tw-text-center">' + descriptionHtml + '</div>' +
            '<div class="embeddables-return__stat-card tw-mt-4">' +
                '<span class="embeddables-return__stat-pct">' + statPct + '%</span>' +
                '<span class="embeddables-return__stat-text">of men like you are satisfied with this treatment</span>' +
            '</div>' +
            (hasAccordion
                ? '<div class="tw-mt-4" data-brx-return-accordion>' +
                    renderAccordionItem('Active Ingredients', activeIngredientsHtml) +
                    renderAccordionItem('What to Know',       whatToKnowHtml) +
                    renderAccordionItem('How to Take',        howToTakeHtml) +
                  '</div>'
                : '') +
        '</div>';
    }

    // -------------------------------------------------------------------------
    // What's Included section
    // -------------------------------------------------------------------------

    function checkmarkSvg() {
        return '<svg class="embeddables-return__check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" width="20" height="20">' +
            '<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>' +
            '</svg>';
    }

    function renderIncluded(product, groupKey) {
        if (!product) return '';
        var title           = escapeHtml(product.title        || '');
        var displayTitle    = escapeHtml(product.displayTitle || '');
        var imageUrl        = (groupKey && GROUP_IMAGES[groupKey]) ? escapeHtml(GROUP_IMAGES[groupKey]) : '';
        var ingredientCount = (product.ingredients && product.ingredients.length) ? product.ingredients.length : 0;

        var badgeHtml = ingredientCount > 0
            ? '<div class="embeddables-return__formula-badge">' + ingredientCount + ' in 1 Formula</div>'
            : '';

        var imageHtml = imageUrl
            ? '<img src="' + imageUrl + '" alt="' + title + '" class="embeddables-return__included-image" loading="lazy">'
            : '<div class="embeddables-return__included-image--placeholder"></div>';

        var itemsHtml = INCLUDED_ITEMS.map(function (item) {
            return '<li class="embeddables-return__included-item">' +
                checkmarkSvg() +
                '<span>' + escapeHtml(item) + '</span>' +
                '</li>';
        }).join('');

        return '<h2 class="embeddables-return__section-heading">What\'s Included?</h2>' +
            '<div class="embeddables-return__included-card tw-p-8">' +
                '<div class="embeddables-return__included-body">' +
                    '<div class="embeddables-return__included-image-wrap">' +
                        imageHtml +
                    '</div>' +
                    '<div class="embeddables-return__included-text">' +
                        badgeHtml +
                        '<p class="tw-text-lg md:tw-text-xl tw-font-medium tw-text-charcoal tw-m-0">' + title + '</p>' +
                        (displayTitle ? '<p class="tw-text-sm md:tw-text-base tw-text-charcoal/70 tw-mt-1 tw-m-0">' + displayTitle + '</p>' : '') +
                    '</div>' +
                '</div>' +
                '<ul class="embeddables-return__included-list">' + itemsHtml + '</ul>' +
            '</div>';
    }

    // -------------------------------------------------------------------------
    // Variant selector for the current selection
    // -------------------------------------------------------------------------

    function renderSelectionVariants(product, activeVariant, promoData, catalog) {
        var selection = buildSelectionVariants(product, catalog);
        if (!selection) return '';

        var buttons = selection.variants.map(function (v) {
            var isActive;
            if (selection.isDailyPair) {
                isActive = v.ccProductId === product.ccProductId;
            } else {
                isActive = activeVariant && String(v.id) === String(activeVariant.id);
            }

            var priceCents = v.priceCents || 0;
            var discount   = calcDiscount(promoData, priceCents);
            var discounted = Math.max(0, priceCents - discount);

            var totalHtml = discount > 0
                ? '<s>' + formatMoney(priceCents) + '</s> ' + formatMoney(discounted)
                : formatMoney(discounted);

            return '<button type="button"' +
                ' class="embeddables-return__variant-btn' + (isActive ? ' embeddables-return__variant-btn--active' : '') + '"' +
                ' data-intake-return-variant-btn' +
                ' data-variant-id="'    + escapeHtml(String(v.id))       + '"' +
                ' data-med-id="'        + escapeHtml(v.medId || '')       + '"' +
                ' data-is-daily-pair="' + (selection.isDailyPair ? 'true' : 'false') + '"' +
                '>' +
                '<div class="embeddables-return__variant-btn-left">' +
                    '<span class="embeddables-return__variant-radio' + (isActive ? ' embeddables-return__variant-radio--active' : '') + '"></span>' +
                    '<span class="embeddables-return__variant-btn-title">' + escapeHtml(v.title) + '</span>' +
                '</div>' +
                '<span class="embeddables-return__variant-btn-price">' + totalHtml + '</span>' +
                '</button>';
        }).join('');

        return '<div class="embeddables-return__variant-selector">' +
            '<p class="embeddables-return__variant-selector-label">' + escapeHtml(selection.optionName) + '</p>' +
            '<div class="embeddables-return__variant-buttons">' + buttons + '</div>' +
        '</div>';
    }

    // -------------------------------------------------------------------------
    // Top-treatments carousel — populate with catalog products
    // -------------------------------------------------------------------------

    function buildCarouselSlideHtml(entry) {
        var p = entry.product;

        var firstVariant = p.hasVariants && p.variants && p.variants[0] ? p.variants[0] : null;
        var variantId    = firstVariant ? String(firstVariant.id) : '';
        var medId        = firstVariant ? (firstVariant.medId || '') : (p.medId || '');
        var displayPrice = p.priceCents != null
            ? formatMoney(p.priceCents)
            : (firstVariant && firstVariant.priceCents != null ? formatMoney(firstVariant.priceCents) : '');

        var imageHtml = p.imageUrl
            ? '<img src="' + escapeHtml(p.imageUrl) + '" alt="' + escapeHtml(p.title) + '" class="embeddables-return__carousel-card-image" loading="lazy">'
            : '<div class="embeddables-return__carousel-card-image embeddables-return__carousel-card-image--placeholder"></div>';

        return '<div class="swiper-slide">' +
            '<button type="button"' +
            ' class="embeddables-return__carousel-card"' +
            ' data-intake-return-select-product' +
            ' data-group-key="'      + escapeHtml(entry.groupKey) + '"' +
            ' data-product-handle="' + escapeHtml(p.handle)       + '"' +
            ' data-variant-id="'     + escapeHtml(variantId)       + '"' +
            ' data-med-id="'         + escapeHtml(medId)           + '"' +
            '>' +
            imageHtml +
            '<span class="embeddables-return__carousel-card-title">' + escapeHtml(p.title) + '</span>' +
            (displayPrice ? '<span class="embeddables-return__carousel-card-price">' + displayPrice + '</span>' : '') +
            '</button>' +
            '</div>';
    }

    function initTopTreatmentsCarousel(returnEl, allProducts) {
        var wrapper = returnEl.querySelector('[data-top-treatments-swiper-wrapper]');
        if (!wrapper || !allProducts || !allProducts.length) return;

        wrapper.innerHTML = allProducts.map(buildCarouselSlideHtml).join('');

        var swiperEl = returnEl.querySelector('.top-treatments-swiper');
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
        }
    }

    // -------------------------------------------------------------------------
    // Reviews carousel
    // -------------------------------------------------------------------------

    function renderReviewSlides() {
        if (!REVIEWS || !REVIEWS.length) return '';
        return REVIEWS.map(function (review) {
            var stars = '';
            for (var i = 0; i < 5; i++) {
                stars += '<span class="embeddables-return__star' + (i < review.stars ? ' embeddables-return__star--filled' : '') + '" aria-hidden="true">&#9733;</span>';
            }
            return '<div class="swiper-slide">' +
                '<div class="embeddables-return__review-card">' +
                    '<div class="embeddables-return__review-stars" aria-label="' + escapeHtml(String(review.stars)) + ' out of 5 stars">' + stars + '</div>' +
                    '<p class="embeddables-return__review-text">' + escapeHtml(review.text) + '</p>' +
                    '<p class="embeddables-return__review-author">&mdash; ' + escapeHtml(review.author) + '</p>' +
                '</div>' +
            '</div>';
        }).join('');
    }

    function initReviewsSwiper(returnEl) {
        var wrapper  = returnEl.querySelector('[data-intake-return-reviews-wrapper]');
        var swiperEl = returnEl.querySelector('[data-intake-return-reviews-swiper]');
        if (!wrapper || !swiperEl) return;

        wrapper.innerHTML = renderReviewSlides();
        if (!REVIEWS || !REVIEWS.length) return;
        if (typeof Swiper === 'undefined') return;

        new Swiper(swiperEl, {
            slidesPerView: 1.1,
            spaceBetween: 12,
            navigation: {
                nextEl: returnEl.querySelector('.brx-reviews-swiper-button-next'),
                prevEl: returnEl.querySelector('.brx-reviews-swiper-button-prev')
            },
            breakpoints: {
                480: { slidesPerView: 1.5 },
                640: { slidesPerView: 2, spaceBetween: 16 }
            }
        });
    }

    // -------------------------------------------------------------------------
    // How It Works — IntersectionObserver scroll-fill
    // rootMargin pushes the trigger point up so steps only activate once
    // they've scrolled well into view, not immediately on page load.
    // -------------------------------------------------------------------------

    function initHowItWorksObserver(returnEl) {
        var steps = returnEl.querySelectorAll('[data-intake-return-step]');
        if (!steps.length || typeof IntersectionObserver === 'undefined') return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2, rootMargin: '0px 0px -150px 0px' });

        steps.forEach(function (step) { observer.observe(step); });
    }

    // -------------------------------------------------------------------------
    // FAQs accordion
    // -------------------------------------------------------------------------

    function renderFaqItems() {
        if (!FAQS || !FAQS.length) return '';
        return FAQS.map(function (faq) {
            return renderAccordionItem(faq.question, '<p class="tw-m-0">' + escapeHtml(faq.answer) + '</p>');
        }).join('');
    }

    function initFaqs(returnEl) {
        var faqAccordion = returnEl.querySelector('[data-intake-return-faqs-accordion]');
        if (!faqAccordion) return;
        faqAccordion.innerHTML = renderFaqItems();
        if (FAQS && FAQS.length) {
            initAccordions(returnEl);
        }
    }

    // -------------------------------------------------------------------------
    // Explore More Treatments accordion
    // -------------------------------------------------------------------------

    function initExploreAccordion(returnEl) {
        var toggle = returnEl.querySelector('[data-intake-return-explore-toggle]');
        var panel  = returnEl.querySelector('[data-intake-return-explore-panel]');
        if (!toggle || !panel) return;
        toggle.addEventListener('click', function () {
            var isOpen = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            panel.classList.toggle('is-open', !isOpen);
        });
    }

    // -------------------------------------------------------------------------
    // Mount
    // -------------------------------------------------------------------------

    function mount(root) {
        var returnEl  = root ? root.querySelector('[data-intake-return]')  : null;
        var overlayEl = root ? root.querySelector('[data-intake-overlay]') : null;
        var hostEl    = root ? root.querySelector('[data-intake-host]')    : null;

        if (!returnEl) return;

        // --- Surface visibility ---
        if (overlayEl) { overlayEl.classList.add('is-hidden'); overlayEl.setAttribute('aria-busy', 'false'); }
        if (hostEl)    hostEl.classList.add('is-hidden');
        returnEl.classList.remove('is-hidden');
        root.classList.remove('is-warmup');

        // --- Tear down prior subscription (bfcache remount) ---
        if (returnEl._brxUnsubscribe) {
            returnEl._brxUnsubscribe();
            returnEl._brxUnsubscribe = null;
        }

        // --- Catalog (static for session lifetime) ---
        var catalog = window.BRXSession && window.BRXSession.getCatalog
            ? window.BRXSession.getCatalog()
            : { groups: [] };
        var allCatalogProducts = buildAllCatalogProducts(catalog);

        // --- One-time static section setup ---
        initHowItWorksObserver(returnEl);
        initReviewsSwiper(returnEl);
        initFaqs(returnEl);
        initTopTreatmentsCarousel(returnEl, allCatalogProducts);
        initExploreAccordion(returnEl);

        // --- Reactive render via BRXSession.subscribe ---
        function renderDynamic() {
            var product = window.BRXSession && window.BRXSession.getSelectionProduct
                ? window.BRXSession.getSelectionProduct()
                : null;
            var sessionState = window.BRXSession && window.BRXSession.getState
                ? window.BRXSession.getState()
                : {};
            var groupKey = (sessionState.selection && sessionState.selection.groupKey) || null;
            var variant = window.BRXSession && window.BRXSession.getSelectionVariant
                ? window.BRXSession.getSelectionVariant()
                : null;
            var resolvedCheckout = window.BRXSession && window.BRXSession.getResolvedCheckoutUrl
                ? window.BRXSession.getResolvedCheckoutUrl()
                : null;
            var checkoutUrl = resolvedCheckout && resolvedCheckout.url ? resolvedCheckout.url : null;
            var promoCode   = window.BRXSession && window.BRXSession.getPromoCode
                ? window.BRXSession.getPromoCode()
                : null;
            var promoData   = null;
            if (promoCode && window.BRXSession && window.BRXSession.getPromos) {
                var promos = window.BRXSession.getPromos();
                promoData = (promos && promos[promoCode]) ? promos[promoCode] : null;
            }

            // Summary + details
            if (product) {
                var summaryEl = returnEl.querySelector('[data-intake-return-summary]');
                var detailsEl = returnEl.querySelector('[data-intake-return-details]');
                if (summaryEl) summaryEl.innerHTML = renderSummary(product);
                if (detailsEl) {
                    detailsEl.innerHTML = renderDetails(product, variant);
                    initAccordions(detailsEl);
                }
            }

            // Both checkout buttons
            var checkoutBtns = returnEl.querySelectorAll('[data-intake-return-checkout], [data-intake-return-checkout-2]');
            checkoutBtns.forEach(function (btn) {
                if (checkoutUrl) {
                    btn.href = checkoutUrl;
                    btn.removeAttribute('aria-disabled');
                    btn.style.opacity      = '';
                    btn.style.pointerEvents = '';
                } else {
                    btn.setAttribute('aria-disabled', 'true');
                    btn.style.opacity      = '0.6';
                    btn.style.pointerEvents = 'none';
                }
            });

            // What's Included
            var includedEl = returnEl.querySelector('[data-intake-return-included]');
            if (includedEl) includedEl.innerHTML = renderIncluded(product, groupKey);

            // Variant selector for current selection
            var variantSelEl = returnEl.querySelector('[data-intake-return-variant-selector]');
            if (variantSelEl) variantSelEl.innerHTML = renderSelectionVariants(product, variant, promoData, catalog);

        }

        if (window.BRXSession && window.BRXSession.subscribe) {
            var unsubscribe = window.BRXSession.subscribe(function () { renderDynamic(); });
            returnEl._brxUnsubscribe = unsubscribe;
        } else {
            renderDynamic();
        }

        // --- Delegated click handler ---
        if (!returnEl._brxSelectorBound) {
            returnEl._brxSelectorBound = true;
            returnEl.addEventListener('click', function (event) {

                // Variant selector buttons (dose/formula toggle for current selection)
                var variantBtn = event.target.closest('[data-intake-return-variant-btn]');
                if (variantBtn) {
                    event.preventDefault();
                    var isDailyPair = variantBtn.getAttribute('data-is-daily-pair') === 'true';
                    var medId       = variantBtn.getAttribute('data-med-id')     || null;
                    var variantId   = variantBtn.getAttribute('data-variant-id') || null;
                    if (isDailyPair && medId && window.BRXSession && window.BRXSession.setSelectionFromMedId) {
                        window.BRXSession.setSelectionFromMedId(medId, 'return_variant_selector');
                    } else if (variantId && window.BRXSession && window.BRXSession.setSelection) {
                        var sessionState = window.BRXSession.getState ? window.BRXSession.getState() : {};
                        var currentSel   = sessionState.selection || {};
                        window.BRXSession.setSelection({
                            groupKey:      currentSel.groupKey      || null,
                            productHandle: currentSel.productHandle || null,
                            variantId:     variantId
                        }, 'return_variant_selector');
                    }
                    return;
                }

                // Product cards in the "Explore More Treatments" grid + carousel
                var card = event.target.closest('[data-intake-return-select-product]');
                if (!card) return;
                event.preventDefault();
                var medId = card.getAttribute('data-med-id') || null;
                if (medId && window.BRXSession && window.BRXSession.setSelectionFromMedId) {
                    window.BRXSession.setSelectionFromMedId(medId, 'return_selector');
                } else if (window.BRXSession && window.BRXSession.setSelection) {
                    window.BRXSession.setSelection({
                        groupKey:      card.getAttribute('data-group-key')      || null,
                        productHandle: card.getAttribute('data-product-handle') || null,
                        variantId:     card.getAttribute('data-variant-id')     || null,
                        medId:         medId
                    }, 'return_selector');
                }
            });
        }
    }

    window.BRXCheckoutReturn = { mount: mount };
})();
